import { useLayoutEffect as useReactLayoutEffect, useEffect } from "react";

/**
 * https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 *
 * useLayoutEffect causes hydration errors with SSR. So on the server, use useEffect,
 * but on the client, use useLayoutEffect.
 */
const useLayoutEffect = typeof window !== "undefined" ? useReactLayoutEffect : useEffect;
// Ensure the name used in components is useLayoutEffect
export { useLayoutEffect };
